/* Arcana: запоминаем подарочную карту на устройстве покупателя.
   Страница карты (checkout.shopify.com) ведёт в магазин по ссылке …/#arc-gc=КОД&v=ОСТАТОК&l=ПОСЛЕДНИЕ4.
   #-часть не уходит на сервер. Код хранится в localStorage этого браузера,
   корзина и окно «добавлено в корзину» напоминают ввести его на оформлении. */
(function () {
  var KEY = 'arcGiftCard';
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save(v) {
    try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {}
  }
  var m = window.location.hash.match(/arc-gc=([A-Za-z0-9]{8,32})(?:&v=(\d+))?(?:&l=([A-Za-z0-9]{4}))?/);
  var justSaved = false;
  if (m) {
    save({ code: m[1].toUpperCase(), v: m[2] ? parseInt(m[2], 10) : null, l: (m[3] || m[1].slice(-4)).toUpperCase(), t: Date.now() });
    justSaved = true;
    try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
  }
  function money(c) { var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }

  function render() {
    var gc = read();
    document.querySelectorAll('[data-arc-gc-reminder]').forEach(function (box) {
      box.innerHTML = '';
      box.hidden = !gc;
      if (!gc) return;
      var t = el('p', 'arc-gcr__text');
      var b = el('b', '', 'Your gift card \u00b7\u00b7\u00b7\u00b7 ' + gc.l + (gc.v ? ' (' + money(gc.v) + ')' : '') + ' is saved.');
      t.appendChild(b);
      t.appendChild(document.createTextNode(' At checkout, paste the code under \u201cDiscount code or gift card\u201d and tap Apply.'));
      var row = el('div', 'arc-gcr__row');
      var copy = el('button', 'arc-gcr__copy', 'Copy code');
      copy.type = 'button';
      copy.addEventListener('click', function () {
        var done = function () { copy.textContent = 'Copied \u2713'; setTimeout(function () { copy.textContent = 'Copy code'; }, 2500); };
        if (navigator.clipboard) navigator.clipboard.writeText(gc.code).then(done, function () { window.prompt('Your gift card code:', gc.code); });
        else window.prompt('Your gift card code:', gc.code);
      });
      var rm = el('button', 'arc-gcr__remove', 'Remove');
      rm.type = 'button';
      rm.addEventListener('click', function () { save(null); render(); });
      row.appendChild(copy);
      row.appendChild(rm);
      box.appendChild(t);
      box.appendChild(row);
    });
  }

  function toast() {
    var gc = read();
    if (!gc) return;
    var n = el('div', 'arc-gcr-toast');
    n.setAttribute('role', 'status');
    n.textContent = 'Your gift card \u00b7\u00b7\u00b7\u00b7 ' + gc.l + ' is saved. We\u2019ll remind you at checkout.';
    document.body.appendChild(n);
    setTimeout(function () { n.classList.add('is-in'); }, 30);
    setTimeout(function () { n.classList.remove('is-in'); setTimeout(function () { n.remove(); }, 400); }, 5200);
  }

  function start() {
    render();
    if (justSaved) toast();
    // корзина и окно перерисовываются после изменений — показываем снова
    var obs = new MutationObserver(function () {
      if (read() && document.querySelector('[data-arc-gc-reminder]:empty')) render();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
